<template>
  <div id="TermsDiv">
    <b-modal size="lg" id="terms_and_conditions_modal" hide-footer>
      <template v-slot:modal-title>
        {{$t('home.policies.terms_title')}}
      </template>
      <div class="d-block text-left">

        <p v-html="$t('home.policies.terms_text')"></p>

      </div>
      <b-button class="btn-block mt-4" block @click="$bvModal.hide('terms_and_conditions_modal')">{{$t('member.close')}}</b-button>
    </b-modal>
  </div>
</template>

<script>


  export default {
    name: 'TermsAndConditionModal',
    mixins: [

    ],
    components: {

    },
    data() {
      return {

      }
    },
    computed: {

    },
    created() {
      //this.$ga.page('/terms_and_conditions');

      // this.$ga.event({
      //     eventCategory: 'category',
      //     eventAction: 'action',
      //     eventLabel: 'label',
      //     eventValue: 123
      // });

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>

